// extracted by mini-css-extract-plugin
export var footer = "_rp-0";
export var inherit = "_rp-1";
export var input = "_rp-2";
export var modalContent = "_rp-3";
export var quillEditor = "_rp-4";
export var subtitle = "_rp-5";